import React from "react";
import instagram from "../Assets/Landing/footer/instagram.png";
import icon3 from "../Assets/Landing/Navbar/LOGO-removebg-preview.png";
import linkedin from "../Assets/Landing/footer/linkedin.png";
import youtube from "../Assets/Landing/footer/youtube.png";
import facebook from "../Assets/Landing/footer/fb3.png";
import x from "../Assets/Landing/footer/twitter.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-background2 py-5 mt-2">
      <div className="flex flex-wrap justify-between text-background px-4 md:px-8 font-josefin">
        {/* Logo and Address Section */}
        <div className="w-full md:w-1/3 p-4">
          <p className="text-3xl mb-6">JobGenee</p>
          <p className="text-justify mb-4 md:pr-8 text-sm md:text-base">
            Unlock Opportunities, Find Your Future Here! Where Talent Meets Opportunity
          </p>
          <p>
            <strong>Add:</strong> 70-80 Upper St Norwich NR2
          </p>
          <p>
            <strong>Call:</strong> +01 123 5641 231
          </p>
          <p>
            <strong>Email:</strong> info@jobgenee.com
          </p>
        </div>

        {/* Quick Links Section */}
        <div className=" mt-3 w-full md:w-1/3 flex justify-around md:justify-evenly pt-6 md:pt-0">
          <div>
            <h3 className=" text-3xl pb-4">Quick Links</h3>
            <ul className="list-none space-y-3 text-sm md:text-base">
              <li>About</li>
              <li>Courses</li>
              <li>
                <Link to="/ForgotPassword">Instructor</Link>
              </li>
              <li>Events</li>
              <li>Instructor Profile</li>
              <li>Purchase Guide</li>
            </ul>
          </div>
          <div>
            <h3 className=" text-3xl pb-4">Links</h3>
            <ul className="list-none space-y-3 text-sm md:text-base">
              <li>
                <Link to="/Contact1">Contact Us</Link>
              </li>
              <li>
                <Link to="/Feedback">Feedback</Link>
              </li>
              <li>
                <Link to="/Dashboard">News & Articles</Link>
              </li>
              <li>
                <Link to="/EmployerRegistrationForm">FAQ'S</Link>
              </li>
              <li>
                <Link to="/HomeLogin">SignUp/SignIn</Link>
              </li>
              <li>Coming Soon</li>
            </ul>
          </div>
        </div>

        {/* Contacts and Newsletter Section */}
        <div className="mt-3 w-full md:w-1/3 pt-6 md:pt-0">
          <h3 className="text-3xl pb-4">Contacts</h3>
          <p className="text-justify mb-4 text-sm md:text-base">
            Register your email to subscribe to our newsletter{" "}
          </p>
          <form className="flex flex-wrap items-center space-y-2 md:space-y-0">
            <input
              type="email"
              placeholder="Your email"
              className="w-full md:w-64 px-4 py-2 border text-black border-gray-300 rounded-l-md md:rounded-none md:rounded-l-md"
            />
            <button
              type="submit"
              className="bg-[rgb(0,44,175)] text-white px-4 py-2 rounded-r-md transition-transform duration-300 transform hover:scale-105 w-full md:w-auto"
            >
              Subscribe →
            </button>
          </form>
          <div className="flex justify-center md:justify-start space-x-6 mt-5">
            <a href="#">
              <img src={facebook} alt="Facebook" className="h-8 w-8" />
            </a>
            <a href="#">
              <img src={linkedin} alt="LinkedIn" className="h-8 w-8" />
            </a>
            <a href="#">
              <img src={instagram} alt="Instagram" className="h-8 w-8" />
            </a>
            <a href="#">
              <img src={x} alt="Twitter" className="h-8 w-8" />
            </a>
            <a href="#">
              <img src={youtube} alt="YouTube" className="h-8 w-8" />
            </a>
          </div>
        </div>
      </div>
      {/* Footer Bottom Section */}
      <div className="text-center py-2 bg-background text-textWhite text-sm md:text-base border-t border-background font-josefin mt-8">
        <strong>&copy; 2024 Jobgenee. All Rights Reserved.</strong>
      </div>
    </footer>
  );
};

export default Footer;
